/* RepeatDayOfWeekOfMonthOfYearComponent.js */

"use strict";
const Renderer = require("./RepeatDayOfWeekOfMonthOfYearRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class RepeatDayOfWeekOfMonthOfYearComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
    static defaultValue() {
        let now = new Date();
        return {
            type: "dowomoy",
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            every: 1,
            moy: 1,
            dowc: 1,
            dow: 2,
            time: {
                hour: 12,
                minute: 0,
            },
            start: {
                year: now.getFullYear(),
                month: now.getMonth(),
                date: now.getDate(),
            },
        };
    }
}
module.exports = RepeatDayOfWeekOfMonthOfYearComponent;
